import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TaskCategoryResponse } from '../models/task.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface TaskCategoryDrawerOptions { categoryId?: number; }

@Injectable({ providedIn: 'root' })
export class TaskCategoryDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: TaskCategoryDrawerOptions }>({
    isOpen: false, options: {}
  });
  private readonly saved$$ = new Subject<TaskCategoryResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: TaskCategoryDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }
  notifySaved(item: TaskCategoryResponse): void { this.saved$$.next(item); }
}
